import { Component } from '@angular/core';

@Component({
  selector: 'app-versioningconfirmationvoyage-popup',
  templateUrl: './versioningconfirmationvoyage-popup.component.html',
  styleUrls: ['./versioningconfirmationvoyage-popup.component.scss']
})
export class VersioningconfirmationvoyagePopupComponent {

}
